/* ────────────────────────────────────────────────────────────
   Divine Designs · global.js
   Header behaviors: mobile menu, search overlay, newsletter modal
   Cart bubble cross-tab sync, Esc key, Cmd+K search
   ──────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function open(name) {
    document.body.classList.add('chrome-locked');
    var overlay = ensureOverlay();
    if (name === 'menu') {
      var m = $('#mobile-menu');
      if (m) { m.classList.add('open'); m.setAttribute('aria-hidden', 'false'); }
      overlay.classList.add('open');
    } else if (name === 'search') {
      if (window.location.pathname.indexOf('size-guide') > -1) return;
      var s = $('#search-overlay');
      if (s) { s.classList.add('open'); s.setAttribute('aria-hidden', 'false'); }
      overlay.classList.add('open');
      var input = $('#search-input');
      if (input) setTimeout(function () { input.focus(); }, 200);
    } else if (name === 'newsletter') {
      var n = $('#newsletter-modal');
      if (n) n.classList.add('open');
    } else if (name === 'cart') {
      var d = $('#cart-drawer');
      if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); }
      var co = $('#cart-drawer-overlay');
      if (co) co.classList.add('open');
    }
  }

  function close(name) {
    if (name === 'menu' || name === 'all') {
      var m = $('#mobile-menu');
      if (m) { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); }
    }
    if (name === 'search' || name === 'all') {
      var s = $('#search-overlay');
      if (s) { s.classList.remove('open'); s.setAttribute('aria-hidden', 'true'); }
    }
    if (name === 'newsletter' || name === 'all') {
      var n = $('#newsletter-modal');
      if (n) n.classList.remove('open');
      try { localStorage.setItem('divine-nl-dismissed', '1'); } catch (e) {}
    }
    if (name === 'cart' || name === 'all') {
      var d = $('#cart-drawer');
      if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
      var co = $('#cart-drawer-overlay');
      if (co) co.classList.remove('open');
    }
    var anyOpen = $('#mobile-menu.open, #search-overlay.open, #newsletter-modal.open, #cart-drawer.open');
    if (!anyOpen) {
      var ov = $('.chrome-overlay');
      if (ov) ov.classList.remove('open');
      document.body.classList.remove('chrome-locked');
    }
  }

  function ensureOverlay() {
    var ov = $('.chrome-overlay');
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'chrome-overlay';
      ov.setAttribute('aria-hidden', 'true');
      ov.addEventListener('click', function () { close('all'); });
      document.body.appendChild(ov);
    }
    return ov;
  }

  function refreshCartBubbles(count) {
    if (typeof count !== 'number' && window.theme && window.theme.cart) count = window.theme.cart.item_count;
    if (typeof count !== 'number') count = 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  // ── Newsletter trigger ──
  function maybeOpenNewsletter() {
    if (!$('#newsletter-modal')) return;
    var dismissed;
    try { dismissed = localStorage.getItem('divine-nl-dismissed') || localStorage.getItem('divine-nl-subscribed'); }
    catch (e) { return; }
    if (dismissed) return;
    var trigger = ($('#newsletter-modal').dataset.trigger || 'exit');
    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (trigger === 'delay' || (trigger === 'exit' && isMobile)) {
      setTimeout(function () { if (!isDismissed()) open('newsletter'); }, isMobile ? 25000 : 15000);
    } else if (trigger === 'scroll') {
      var fired = false;
      window.addEventListener('scroll', function () {
        if (fired) return;
        var pct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
        if (pct > 0.5 && !isDismissed()) { fired = true; open('newsletter'); }
      }, { passive: true });
    } else {
      // exit-intent on desktop
      var fired = false;
      document.addEventListener('mouseleave', function (e) {
        if (!fired && e.clientY < 5 && !isDismissed()) { fired = true; setTimeout(function () { if (!isDismissed()) open('newsletter'); }, 100); }
      });
    }
  }

  function isDismissed() {
    try { return localStorage.getItem('divine-nl-dismissed') || localStorage.getItem('divine-nl-subscribed'); }
    catch (e) { return false; }
  }

  // ── Universal accordion ──
  function bindAccordions() {
    document.addEventListener('click', function (e) {
      var head = e.target.closest('.accordion-header');
      if (!head) return;
      var item = head.closest('.accordion-item');
      if (!item) return;
      item.classList.toggle('open');
      var expanded = item.classList.contains('open');
      head.setAttribute('aria-expanded', expanded);
    });
  }

  // ── Init ──
  function init() {
    ensureOverlay();
    refreshCartBubbles();
    bindAccordions();

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-chrome-trigger]');
      if (trigger) { e.preventDefault(); open(trigger.dataset.chromeTrigger); return; }
      var closer = e.target.closest('[data-chrome-close]');
      if (closer) { close(closer.dataset.chromeClose); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close('all');
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); open('search'); }
    });

    window.addEventListener('storage', function (e) {
      if (e.key === 'divine-cart-count') refreshCartBubbles(parseInt(e.newValue, 10));
    });

    // Newsletter form success → mark subscribed
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.nm-form');
      if (form) {
        try { localStorage.setItem('divine-nl-subscribed', '1'); } catch (err) {}
      }
    });

    // Newsletter popup auto-fire — DISABLED 2026-05-12 per UX request.
    // The popup can still open via explicit triggers (e.g., footer link,
    // [data-chrome-trigger="newsletter"]), but it will no longer auto-pop
    // on delay/exit-intent/scroll. To re-enable site-wide, uncomment:
    // setTimeout(maybeOpenNewsletter, 500);

    // Back-to-top smooth scroll
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-back-to-top]');
      if (!btn) return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    bindMegaNav();
  }

  // ── Mega-nav (Stories / Apparel mega panels + mini dropdowns) ──
  function bindMegaNav() {
    var nav = document.querySelector('[data-mega-nav]');
    var scrim = document.querySelector('[data-nav-scrim]');
    if (!nav) return;

    var openContainer = null; // currently-open .nav-mega or .nav-mini element
    var hoverDelay;

    // Track whether the mega panel was the one to add the body-lock class,
    // so we only remove it on close if no other chrome surface is open.
    var megaLockedBody = false;

    function isAnyDrawerOpen() {
      var mm = document.getElementById('mobile-menu');
      var co = document.getElementById('cart-drawer');
      var so = document.getElementById('search-overlay');
      return (mm && mm.classList.contains('open'))
          || (co && co.classList.contains('open'))
          || (so && so.classList.contains('open'));
    }

    function openPanel(container) {
      if (openContainer === container) return;
      closePanel();
      var trigger = container.querySelector('[data-nav-trigger]');
      var panel = container.querySelector('.nav-mega__panel, .nav-mini__panel');
      if (!trigger || !panel) return;
      // Align the mega panel (and scrim) to the header's ACTUAL bottom edge so
      // it never overlaps the header. Correct whether the promo bar is visible
      // (header pushed down) or scrolled away (header stuck to the top).
      if (container.classList.contains('nav-mega')) {
        var headerEl = document.querySelector('.site-header');
        if (headerEl) {
          var topPx = Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom));
          panel.style.top = topPx + 'px';
          if (scrim) scrim.style.top = topPx + 'px';
        }
      }
      panel.removeAttribute('hidden');
      requestAnimationFrame(function () { panel.classList.add('is-visible'); });
      trigger.setAttribute('aria-expanded', 'true');
      container.classList.add('is-open');
      // Mega-panel only: show scrim + lock body scroll. Mini dropdowns
      // are small and shouldn't lock — they don't cover meaningful viewport.
      if (container.classList.contains('nav-mega')) {
        if (scrim) scrim.removeAttribute('hidden');
        if (!document.body.classList.contains('chrome-locked')) {
          document.body.classList.add('chrome-locked');
          megaLockedBody = true;
        }
      }
      openContainer = container;
    }

    function closePanel() {
      if (!openContainer) return;
      var trigger = openContainer.querySelector('[data-nav-trigger]');
      var panel = openContainer.querySelector('.nav-mega__panel, .nav-mini__panel');
      if (panel) {
        panel.classList.remove('is-visible');
        setTimeout(function () { if (!panel.classList.contains('is-visible')) panel.setAttribute('hidden', ''); }, 200);
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      openContainer.classList.remove('is-open');
      if (scrim) scrim.setAttribute('hidden', '');
      // Only release the body lock if WE added it and no other drawer
      // is currently using it.
      if (megaLockedBody && !isAnyDrawerOpen()) {
        document.body.classList.remove('chrome-locked');
      }
      megaLockedBody = false;
      openContainer = null;
    }

    // Click on a trigger toggles its panel
    nav.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-nav-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var container = trigger.closest('.nav-mega, .nav-mini');
      if (!container) return;
      if (openContainer === container) closePanel();
      else openPanel(container);
    });

    // Hover-intent on desktop
    nav.querySelectorAll('.nav-mega, .nav-mini').forEach(function (container) {
      container.addEventListener('mouseenter', function () {
        if (window.innerWidth < 1024) return;
        clearTimeout(hoverDelay);
        hoverDelay = setTimeout(function () { openPanel(container); }, 120);
      });
      container.addEventListener('mouseleave', function (e) {
        if (window.innerWidth < 1024) return;
        clearTimeout(hoverDelay);
        // Only close if leaving toward a non-panel area
        var related = e.relatedTarget;
        if (related && container.contains(related)) return;
        hoverDelay = setTimeout(function () {
          if (openContainer === container) closePanel();
        }, 280);
      });
    });

    // Click outside / scrim closes
    document.addEventListener('click', function (e) {
      if (!openContainer) return;
      if (openContainer.contains(e.target)) return;
      if (e.target.closest('[data-nav-scrim]')) { closePanel(); return; }
      closePanel();
    });

    // ESC closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openContainer) closePanel();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.theme = window.theme || {};
  window.theme.chrome = { open: open, close: close, refreshCartBubbles: refreshCartBubbles };
})();
